import { Tag } from 'antd'
import { useOfficeReviewStatuses } from '@/hooks'
import { isValidHexColor, readableTextColor } from '@/utils/color'

const UNSET_FALLBACK_COLOR = '#d9d9d9'

interface OfficeReviewStatusTagProps {
  /** office_review_status_master.id。null/undefined は未設定（-）。 */
  statusId?: number | null
  /** 未設定（-）のとき何も描画しない場合 true。デフォルトは淡色の「-」を描画。 */
  hideWhenUnset?: boolean
}

/**
 * 事務局確認用ステータス（顧客要望 管理No.25）の表示チップ。
 * マスタの表示色を背景に、輝度から読みやすい文字色を自動選択する。
 * 一覧・詳細など読み取り表示で共通利用する。
 */
export default function OfficeReviewStatusTag({ statusId, hideWhenUnset }: OfficeReviewStatusTagProps) {
  const { byId } = useOfficeReviewStatuses()
  const status = statusId != null ? byId.get(statusId) : undefined

  if (!status) {
    if (hideWhenUnset) return null
    return <span style={{ color: 'rgba(0, 0, 0, 0.45)' }}>—</span>
  }

  const background = isValidHexColor(status.color) ? status.color : UNSET_FALLBACK_COLOR
  return (
    <Tag style={{ backgroundColor: background, color: readableTextColor(background), border: 'none', margin: 0 }}>
      {status.displayName}
    </Tag>
  )
}
